import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import { BFormGroup, BInputGroup, BRow, BCol } from 'bootstrap-vue'
import {
  KForm,
  KFormCheckboxGroup,
  KFormCheckbox,
  KFormDatepicker,
  KFormEditor,
  KFormNumber,
  KFormSelect,
  KFormSpinner
} from '@kwixeo/form-vue'
import { SaleTermsSelect, PdfModelSelect } from '@kwixeo/sales-vue'
import { PaymentTermSelect, VatRateSelect, CurrencySelect } from '@kwixeo/interface-vue'
import { mapActions, mapGetters, mapState } from 'vuex'

@Component({
  components: {
    KForm, KFormCheckboxGroup, KFormCheckbox, KFormNumber, KFormSelect, KFormDatepicker, KFormEditor, KFormSpinner,
    BFormGroup, BInputGroup, BRow, BCol,
    SaleTermsSelect, PdfModelSelect,
    VatRateSelect, CurrencySelect,
    PaymentTermSelect
  },
  methods: {
    ...mapActions('globalDatas', ['loadPaymentMethods'])
  },
  computed: {
    ...mapState('globalDatas', ['paymentMethods']),
    ...mapGetters('subscriptions', ['hasModule']),
    ...mapGetters('user', ['can'])
  }
})
export default class CustomerSaleParams extends Vue {
  loadPaymentMethods!: (force?: boolean) => Promise<void>
  paymentMethods!: KwixeoFramework.PaymentMethods
  hasModule!: (key: string) => boolean
  can!: (key: string, level: number) => boolean

  @Prop({ required: true }) value!: KwixeoCustomers.Customer
  @Prop({ default: true }) withForm!: boolean

  private localConfig: KwixeoFramework.ConfigAttributes = {}
  private selectedPaymentMethods: number[] = []

  protected selectVatRates = [
    { id: true, label: this.$t('sales.form.inputOptions.vatrateSelectionOne') },
    { id: false, label: this.$t('sales.form.inputOptions.vatrateSelectionMultiple') }
  ]

  protected amountsType = [
    { id: 'ht', label: this.$t('sales.form.inputOptions.amountTypesHt') },
    { id: 'ttc', label: this.$t('sales.form.inputOptions.amountTypesTtc') }
  ]

  protected amounts = [
    { id: 1, label: this.$t('sales.form.pdfOptions.amountsChoice1') },
    { id: 2, label: this.$t('sales.form.pdfOptions.amountsChoice2') },
    { id: 3, label: this.$t('sales.form.pdfOptions.amountsChoice3') },
    { id: 4, label: this.$t('sales.form.pdfOptions.amountsChoice4') }
  ]

  async mounted (): Promise<void> {
    await this.loadPaymentMethods()
  }

  get formAttributes (): KwixeoInterface.GenericObject {
    return {
      action: this.formAction,
      method: 'PUT',
    }
  }

  get formEvents (): KwixeoInterface.GenericObject {
    return {
      submitComplete: this.formSubmitted
    }
  }

  get formAction (): string {
    return '/customer/' + this.value.id
  }

  @Watch('value', { immediate: true })
  private watchValue (value: KwixeoCustomers.Customer): void {
    this.localConfig = JSON.parse(JSON.stringify(value.configs ?? {}))
  }

  @Watch('localConfig.sales_payment_methods', { immediate: true })
  private watchSalesPaymentMethods (): void {
    const methods: KwixeoFramework.PaymentMethods = this.localConfig.sales_payment_methods ? this.localConfig.sales_payment_methods : []
    this.selectedPaymentMethods = methods.map(method => method.id)
  }

  private formSubmitted (response: AxiosResponse): void {
    this.$emit('input', response.data)
  }
}
